// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3g4gz","bgIcon":"DeVZr","content":"_22pfP","title":"_2qK37","desc":"_3gFHy","countdown":"_1WlHD","contactUs":"_2_k6Z","saveBtn":"dRZ1L"};